import {
  StatsByMonthRequestData,
  StatsResultsResponseRow,
} from '../../../types/api/endpoints/stats/results.types';
import { STATS_ENDPOINTS } from '../../../utils/api/endpoints/statsEndpoints';
import {} from './useStatsByMonth.types';

const PREFIX = '[statsByMonthQuery]';

export const statsByMonthQuery = async (data: StatsByMonthRequestData) => {
  console.log(PREFIX, `Fetching stats results...`);

  const response = await STATS_ENDPOINTS.statsByMonth(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received stats results..`);
  return json as StatsResultsResponseRow[];
};
